var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cp-select',_vm._g(_vm._b({attrs:{"config":_vm.routeData,"item-value":"id","item-text":"trade_name","clearable":"","persistent":true}},'cp-select',_vm.attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }